
document.addEventListener('click', (e) => {
  if (e.target.tagName === 'A' || e.target.closest('a')) {
    const link = e.target.tagName === 'A' ? e.target : e.target.closest('a')
    if (link.getAttribute('href')?.slice(0,4).toLowerCase() === 'http') {
      window.open(link.href)
    }
  }
})


export function msieversion() {

  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
    return true
  }
  return false
}